import { useTableActionContext } from '@aibees/elephant/context';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { useMemo } from 'react';
import { convertOptionsToTemplateCategories } from '../utils/options-converter';

export const useExportOptions = () => {
  const { data } = useBootstrapApi();
  const { integrationConfig } = useTableActionContext();
  const searchType = useSearchTypeFromRoute();

  const templateCategories = useMemo(() => {
    const titles = data?.export.titles || {};
    return convertOptionsToTemplateCategories(
      titles,
      integrationConfig,
      searchType
    );
  }, [data?.export.titles, integrationConfig, searchType]);
  const companyOptions = useMemo(() => {
    return templateCategories.find(
      (i) => i.key.toLocaleLowerCase() === 'company'
    );
  }, [templateCategories]);

  const emailOptions = useMemo(() => {
    return templateCategories.find(
      (i) => i.key.toLocaleLowerCase() === 'email'
    );
  }, [templateCategories]);

  const peopleOptions = useMemo(() => {
    return templateCategories;
  }, [templateCategories]);

  return {
    companyOptions,
    peopleOptions,
    emailOptions,
  };
};
